
import { API_Authenticate, API_GetConfig, API_GetMerchantParams, API_Geti18n } from 'app/api'
import { CustomerData, ReturnData, PickupPointData } from 'app/types'

export enum SessionActionType {
  Initialize = 'gelAction-init',
  UpdateConfig = 'gelAction-updateConfig',
  Updatei18n = 'gelAction-updatei18n',
  UpdateMerchantParams = 'gelAction-updateMerchantParams',
  Authenticate = 'gelAction-authenticate',
  UpdateOrder = 'gelAction-updateOrder',
  Logout = 'gelAction-logout',
}
export type SessionAction = Initialize | UpdateConfig | Updatei18n | UpdateMerchantParams | Authenticate | Logout | UpdateOrder

export type OrderData = {
  customer: CustomerData
  return: ReturnData
  pickupPoint: PickupPointData
}

export type Initialize = {
  type: typeof SessionActionType.Initialize
  data: boolean
}
export function initialize(data: boolean): Initialize {
  return { type: SessionActionType.Initialize, data: data }
}

export type UpdateConfig = {
  type: typeof SessionActionType.UpdateConfig
  data: API_GetConfig
}
export function updateConfig(data: API_GetConfig): UpdateConfig {
  return { type: SessionActionType.UpdateConfig, data: data }
}

export type Updatei18n = {
  type: typeof SessionActionType.Updatei18n
  data: API_Geti18n
}
export function updatei18n(data: API_Geti18n): Updatei18n {
  return { type: SessionActionType.Updatei18n, data: data }
}

export type UpdateMerchantParams = {
  type: typeof SessionActionType.UpdateMerchantParams
  data: API_GetMerchantParams
}
export function updateMerchantParams(data: API_GetMerchantParams): UpdateMerchantParams {
  return { type: SessionActionType.UpdateMerchantParams, data: data }
}

export type Authenticate = {
  type: typeof SessionActionType.Authenticate
  data: API_Authenticate
}
export function updateAuth(data: API_Authenticate): Authenticate {
  return { type: SessionActionType.Authenticate, data: data }
}

export type Logout = {
  type: typeof SessionActionType.Logout
}
export function logout(): Logout {
  return { type: SessionActionType.Logout }
}

export type UpdateOrder = {
  type: typeof SessionActionType.UpdateOrder
  data: OrderData
}
export function updateOrder(data: OrderData): UpdateOrder {
  return { type: SessionActionType.UpdateOrder, data: data }
}